import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

export interface SiteConfig {
  host: string;
  description?: string;
  enabled: boolean;
  password?: string; // Only for setting, not returned on GET usually (or hashed)
}

@Injectable({
  providedIn: 'root'
})
export class ManagementService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getSites(): Observable<SiteConfig[]> {
    return this.http.get<SiteConfig[]>(`${this.apiUrl}/sites`, { withCredentials: true });
  }

  createSite(site: SiteConfig): Observable<SiteConfig> {
    return this.http.post<SiteConfig>(`${this.apiUrl}/sites`, site, { withCredentials: true });
  }

  updateSite(host: string, site: Partial<SiteConfig>): Observable<SiteConfig> {
    return this.http.put<SiteConfig>(`${this.apiUrl}/sites/${host}`, site, { withCredentials: true });
  }

  deleteSite(host: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/sites/${host}`, { withCredentials: true });
  }
}


